import React, { ChangeEvent } from "react";
import { fileToBase64 } from "lib/common/convert-data";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});

interface ChangeAvatarProps {
	setShowMessage: React.Dispatch<
		React.SetStateAction<{
			open: boolean;
			message: string | string[];
			type: "error" | "success" | "info" | "warning";
		}>
	>;
	setImageChange: (e: string) => void;
	isLoading: boolean;
  handleChangeImage: Function
}

const ChangeAvatar = ({
	setShowMessage,
	setImageChange,
	isLoading,
  handleChangeImage
}: ChangeAvatarProps) => {
	return (
		<>
			<Button
				variant="contained"
				size="large"
				fullWidth
				color="primary"
				component="label"
				sx={{
					margin: "2rem 0 1rem 0",
					maxWidth: "400px",
				}}
			>
				アバターアップロード（任意）
				<VisuallyHiddenInput
					type="file"
					accept={window.innerWidth >= 600 ? ".png, .jpg, .jpeg" : undefined}
					onChange={async (e: ChangeEvent<HTMLInputElement>) => {
						if (e.target.files && e.target.files.length) {
							if (
								e.target.files[0]?.type !== "image/png" &&
								e.target.files[0]?.type !== "image/jpeg" &&
								e.target.files[0]?.type !== "image/jpg"
							) {
								setShowMessage({
									open: true,
									message: "不明な画像形式です",
									type: "error",
								});
							} else if (e.target.files[0]?.size > 5000000) {
								setShowMessage({
									open: true,
									message: "画像は5MB以下でアップロードしてください",
									type: "error",
								});
							} else {
								const convertString =
									(await fileToBase64(e.target.files[0])) || "";
								setImageChange(convertString);
							}
						}
					}}
				/>
			</Button>
			<Button
				sx={{ margin: "1rem 0" }}
				variant="contained"
				disabled={isLoading}
				onClick={() => handleChangeImage()}
			>
				変更
			</Button>
		</>
	);
};

export default ChangeAvatar;
